import React from 'react';
import classNames from 'classnames';
import useGlobalParams from '../../hooks/useGlobalParams';
import useStatuses from '../../hooks/useStatuses';
import useUsers from '../../hooks/useUsers';
import LEAD_FIELDS from '../../utils/leadFields';
import { userFullName } from '../../utils/userUtils';

import FilterDropdown from './FilterDropdown';
import './FilterBar.scss';

export default function FilterBar({ filters, setFilters, removeFromTop }) {

  const { organizationId, categoryId } = useGlobalParams();
  const { data: statuses } = useStatuses({ categoryId });
  const { data: users } = useUsers({ organizationId, categoryId });

  const deleteFilter = index => {
    setFilters(draft => {
      draft.splice(index, 1);
    });
  }

  const renderFilterText = filter => {
    if (filter.field === 'status_id') {
      return (
        <>
          <span className='field'>{ LEAD_FIELDS[filter.field].label }</span> <span className='match'>{filter.match}</span>  
          { filter.value.map((value, index) => <><span className='search'>{ statuses.find(status => status.id === value).name }</span> { index < filter.value.length - 1 && ' or ' }</> )}
        </>
      );
    }
    else if (filter.field === 'assigned_user_id') {
      return (
        <>
          <span className='field'>{ LEAD_FIELDS[filter.field].label }</span> <span className='match'>{filter.match}</span> <span className='search'>{ userFullName(users.find(user => user.id === filter.value)) }</span>
        </>
      );
    }
    else {
      return (
        <><span className='field'>{ LEAD_FIELDS[filter.field].label }</span> <span className='match'>{filter.match}</span> <span className='search'>{filter.value}</span></>
      );
    }
  }

  const renderFilter = (filter, index) => (
    <div key={filter.field} className='selected-filter'>
      <FilterDropdown toggle={EditFilterToggle} filters={filters} setFilters={setFilters} index={index}>
        { renderFilterText(filter) }
      </FilterDropdown>

      <button className='remove-filter' onClick={() => deleteFilter(index)}>✕</button>
    </div>
  );

  return (
    <div className={classNames('__filter-bar', { '__filter-bar-remove-from-top': removeFromTop })}>
      <div className='content'>
        <div className='filters'>
          { filters.map((filter, index) => renderFilter(filter, index)) }
          <FilterDropdown toggle={PlusToggle} filters={filters} setFilters={setFilters}>+</FilterDropdown>
        </div>

        <button className='clear-filter' onClick={() => setFilters([])}>Clear Filter</button>
      </div>
    </div>
  )
}

const EditFilterToggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props} className='edit-filter'>
    { children }
  </button>
));

const PlusToggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props} className='add-filter'>
    { children }
  </button>
));

